import './ProductItemDetailBox.css';

export function ProductItemDetailBox(props: { title: string; children: React.ReactNode; className?: string }) {
   return (
      <div className={`product-item-detail-box ${props.className}`}>
         <div className="title">{props.title}</div>
         <div className="value flex gap-1 items-center">{props.children}</div>
      </div>
   );
}
